import {
    APPTOOLBAR_BASIC_RESET_APP_STATE,
    APPTOOLBAR_RESET_APP_STATE,
    DRAWINGTOOLBAR_BACKGROUND_EDIT,
    DRAWINGTOOLBAR_BACKGROUND_LOADED, DRAWINGTOOLBAR_CLEAR_RULERS_ON_SCREEN,
    DRAWINGTOOLBAR_SCALE_EDIT, DRAWINGTOOLBAR_SCALE_SHOW, MULTIBED_RESET_APP_STATE,
    SCALELINE_END_MEASURING,
    SCALELINE_START_MEASURING,
} from "../lib/types";

const initialState = {
    active: false,
    points: []
};

export default (state = initialState, action) => {
    let points;
    /* discriminate the action type */
    switch (action.type) {
        case SCALELINE_START_MEASURING:
            /* create new points array */
            points = [];
            /* add initial point */
            points.push(action.payload.x, action.payload.y);

            return {
                ...state,
                points: points
            };

        case SCALELINE_END_MEASURING:
            /* make a copy of the points */
            points = state.points.slice();
            /* add initial point */
            points.push(action.payload.x, action.payload.y);

            return {
                ...state,
                points: points
            };

        case DRAWINGTOOLBAR_SCALE_EDIT:
            /* create new points array */
            points = [];
            return {
                ...state,
                points: points,
                active: action.payload
            };

        case DRAWINGTOOLBAR_SCALE_SHOW:
            return {
                ...state,
                active: action.payload.active,
                points: action.payload.points
            };

        case DRAWINGTOOLBAR_BACKGROUND_EDIT:
            if (!action.payload) {
                return state;
            } else {
                return initialState;
            }

        case DRAWINGTOOLBAR_CLEAR_RULERS_ON_SCREEN:
            return initialState;

        case DRAWINGTOOLBAR_BACKGROUND_LOADED:
            return initialState;

        case APPTOOLBAR_BASIC_RESET_APP_STATE:
        case MULTIBED_RESET_APP_STATE:
        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/scaleline-reducer.js